import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_LOCATIONS = false


/*
 * Locations Actions
 *
 */

export function fetchLocationsList(dispatch) {
    let cmd = 'FETCH_LOCATIONS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_LOCATIONS)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('Locations');
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchLocationError(dispatch) {

    dispatch(
        {
            type: 'FETCH_LOCATION_ERROR',
        }
    )
}

export function createLocation(location) {
    let cmd = 'CREATE_LOCATION'

    if (EMULATION_ALL || EMULATION_MODE_LOCATIONS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: location
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('Locations'), JSON.stringify(location), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchLocation(id) {
    let cmd = 'FETCH_LOCATION'

    if (EMULATION_ALL || EMULATION_MODE_LOCATIONS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('Locations/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateLocation(id, location) {
    let cmd = 'UPDATE_LOCATION'

    if (EMULATION_ALL || EMULATION_MODE_LOCATIONS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: location
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('Locations/') + id, JSON.stringify(location), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorLocation(dispatch) {

    dispatch(
        {
            type: 'LOCATION_ERROR',
        }
    )
}

export function fetchStatesList(dispatch) {
    let cmd = 'FETCH_STATES_LIST'

    if (EMULATION_ALL || EMULATION_MODE_LOCATIONS)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    //TODO
                    data: []
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('States');
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}
